<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title font-medium-1 display-inline-block" id="striped-row-layout-icons">{{ routeTitle }}</h4>
        <a *ngIf="!hideButton" (click)="goToAdd()" class="btn btn-raised btn-primary pull-right">{{ actionBtnText }}</a>
      </div>
      <div class="card-body">
        <div class="px-3 pb-3">
          <div class='drag-drop-wrapper'>
            <div class='drag-drop-container' cdkDropList (cdkDropListDropped)="onDrop($event)">
              <div *ngFor="let item of items" class="row cursor-pointer" cdkDrag>
                <div class="col-md-2">
                  <span>{{ item.id }} </span>
                </div>
                <div class="col-md-8">
                  <span>{{ item.name }} </span>
                </div>
                <div class="col-md-2">
                  <span class="icon-pencil info mr-2" (click)="goToEdit(item.id)"></span>
                  <span class="icon-trash danger" (click)="delete(item.id)"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>